import {EOfferScopeStatus} from '../types/enum'

export const STATUS_COLORS_MAP: Record<EOfferScopeStatus, string> = {
	[EOfferScopeStatus.closed]: 'bg-danger',
	[EOfferScopeStatus.active]: 'bg-success',
	[EOfferScopeStatus.paused]: 'bg-warning',
	[EOfferScopeStatus.none]: 'bg-grey',
}